import React, { useContext, useEffect, useRef, useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import MenuTop from "../../components/MenuTop/MenuTop";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ContractUploadPanel from "../../components/ContractUploadPanel/ContractUploadPanel";
import PdfEditor from "../../components/PdfEditor/PdfEditor";
import { DocumentTypeContext } from "../../context/DocumentContext";
import { To, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { usePrompt } from "../../utils/usePrompt";
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  CustomInput,
} from "reactstrap";
import InputStandard from "../../components/Inputs/InputStandard";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useToast } from "../../context/ToastContext";
import Joyride, { Step } from "react-joyride";
import { Card, CardBody, CardTitle, CardText } from "reactstrap";
import { FaTrashAlt } from "react-icons/fa";
import Autocomplete from "@mui/material/Autocomplete";
import { ContactContext } from "../../context/ContactContext";
import { jwtDecode } from "jwt-decode";
import ModaMobileLogin from "../../components/ModaMobileLogin/ModaMobileLogin";
import InputMask from "react-input-mask";
import { MaskedPhoneInput } from "../../components/Inputs/IMaskInput";

export const CustomTextField = styled(TextField)({
  "& label": {
    color: "#75788D",
  },
  "& label.Mui-focused": {
    color: "#75788D",
  },
  "& .MuiInput-underline:before": {
    borderBottomColor: "#F9B233",
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
    borderBottomColor: "#F9B233",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#F9B233",
  },
});

const AddSignatories: React.FC = () => {
  const {
    getDocumentSign,
    getSignersEdit,
    setNameDocument,
    setIdEditDocument,
    nameDocument,
    collaborators,
    setCollaborators,
    signersEdit,
    setTutorial,
    tutorial,
    tableDocuments,
  } = useContext(DocumentTypeContext);
  const { getContactByEmail } = useContext(ContactContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isDirty, setIsDirty] = useState(true);
  const showToast = useToast();
  const [newCollaborator, setNewCollaborator] = React.useState("");
  const [newCollaboratorName, setNewCollaboratorName] = useState("");
  const [newCollaboratorPhoneNumber, setNewCollaboratorPhoneNumber] =
    useState("");
  const [addToContacts, setAddToContacts] = useState(true);
  const [sendMessageWhatsApp, setSendMessageWhatsApp] = useState(false);
  const [requireSignerDocument, setRequireSignerDocument] = useState(false);
  const [selectedFieldType, setSelectedFieldType] = React.useState("email");
  const [emailOptions, setEmailOptions] = useState<any[]>([]);
  const [emailDatabase, setEmailDatabase] = useState<any[]>([]);
  const [sequentialSigning, setSequentialSigning] = useState(false);

  const isValidEmail = (email: any) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValidPhone = (phone: any) => /^\(\d{2}\) \d{5}-\d{4}$/.test(phone);
  const containerRef = useRef(null);

  const params = new URLSearchParams(location.search);
  const documentId = params.get("edit");

  let objUserTk;
  if (localStorage.getItem("token")) {
    objUserTk = jwtDecode(localStorage.getItem("token") || "") as any;
  } else {
    objUserTk = {};
  }

  const handleAddCollaborator = () => {
    if (newCollaboratorName.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Por favor, insira um nome válido.",
      });
      return;
    }

    if (sendMessageWhatsApp) {
      const phoneRegex = /^\+55 \(\d{2}\) \d{4,5}-\d{4}$/;

      if (!phoneRegex.test(newCollaboratorPhoneNumber)) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Para enviar uma mensagem no WhatsApp, informe um número de telefone completo e válido com DDD.",
        });
        return;
      }
    }

    const isValidInput =
      (selectedFieldType === "email" && isValidEmail(newCollaborator.trim())) ||
      (selectedFieldType === "phone" && isValidPhone(newCollaborator.trim()));

    if (isValidInput) {
      setCollaborators([
        ...collaborators,
        {
          id: collaborators.length + 2,
          name: newCollaboratorName,
          email: newCollaborator,
          phoneNumber: newCollaboratorPhoneNumber,
          addToContacts: addToContacts,
          sendMessageWhatsApp: sendMessageWhatsApp,
          requireSignerDocument: requireSignerDocument,
          signature: "",
          date: "",
          fieldType: selectedFieldType,
        },
      ]);

      setNewCollaborator("");
      setNewCollaboratorName("");
      setNewCollaboratorPhoneNumber("");

      setTimeout(() => {
        if (containerRef.current) {
          //@ts-ignore
          containerRef.current.scrollTo({
            //@ts-ignore
            top: containerRef.current.scrollHeight,
            behavior: "smooth",
          });
        }
      }, 100);
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: `Por favor, insira um ${
          selectedFieldType === "email" ? "e-mail" : "número de telefone"
        } válido.`,
      });
    }
  };

  const handleNavigate = () => {
    console.log("col", collaborators);
    if (!nameDocument) {
      showToast("info", "Nome do documento não pode ser vazio");
      return;
    }
    if (collaborators.length === 0) {
      showToast("info", "Adicione pelo menos 1 signatário");
      return;
    }

    if (sequentialSigning) {
      const N = collaborators.length;

      const rawPositions = collaborators.map((c: any) => c.signPosition);

      if (
        rawPositions.some((p: any) => p === "" || p === undefined || p === null)
      ) {
        showToast(
          "info",
          "Preencha a posição na fila para todos os signatários."
        );
        return;
      }

      const positions = rawPositions.map((p: any) => Number(p));
      if (positions.some((p: any) => !Number.isInteger(p) || p < 1 || p > N)) {
        showToast("info", `Posições devem ser inteiras entre 1 e ${N}.`);
        return;
      }

      if (new Set(positions).size !== N) {
        showToast("info", "Posições na fila não podem se repetir.");
        return;
      }
    }

    let path = "/admin/create-documents";

    if (documentId) {
      path += `?edit=${documentId}`;
    }

    navigate(path);
  };

  const handleDeleteCollaborator = (index: any) => {
    const updatedCollaborators = [...collaborators];
    updatedCollaborators.splice(index, 1);
    setCollaborators(updatedCollaborators);
  };

  const handleJoyrideCallback = (data: any) => {
    const { status } = data;
    if (status === "finished" || status === "skipped") {
      setTutorial(false);
    }
  };

  const steps: Step[] = [
    {
      target: "#document-name-input",
      content: "Digite o nome do documento a ser assinado.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#signer-name-input",
      content: "Digite o nome do signatário.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#signer-email-input",
      content: "Digite o e-mail do signatário.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#signer-phone-input",
      content: "Insira o telefone do signatário.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#add-to-contacts-checkbox",
      content:
        "Marque esta opção se deseja salvar este signatário em seus contatos.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: "#add-to-required-document",
      content:
        "Marque esta opção se deseja solicitar um documento do signatário ao assinar.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: "#add-signatario-button",
      content: "Clique aqui para adicionar o signatário à lista.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#next-document",
      content: "Após adicionar os signatários, clique aqui para continuar.",
      placement: "left",
      disableBeacon: true,
    },
  ];

  useEffect(() => {
    const fetchEmails = async () => {
      if (newCollaborator.length >= 3) {
        try {
          const response = await getContactByEmail(
            newCollaborator,
            objUserTk.UserId
          );

          console.log("response", response);
          if (response && Array.isArray(response)) {
            setEmailOptions(response.map((user: any) => user.email));
            setEmailDatabase(response);
          }
        } catch (error) {
          console.error("Erro ao buscar contatos:", error);
        }
      } else {
        setEmailOptions([]);
      }
    };

    fetchEmails();
  }, [newCollaborator]);

  const handleSelectEmail = (
    event: React.SyntheticEvent,
    selectedEmail: string | null
  ) => {
    if (selectedEmail) {
      const user = emailDatabase.find((user) => user.email === selectedEmail);
      console.log("user", user);
      if (user) {
        setNewCollaborator(user.email);
        setNewCollaboratorName(user.name);
        setNewCollaboratorPhoneNumber(user.phoneNumber);
      }
    }
  };

  function handleSignPositionChange(idx: number, value: string) {
    const raw = value.trim();
    const n = raw === "" ? "" : Number(raw);

    setCollaborators((prev: any) =>
      prev.map((c: any, i: any) =>
        i === idx
          ? {
              ...c,
              signPosition:
                raw === ""
                  ? ""
                  : Math.max(
                      1,
                      Math.min(
                        prev.length,
                        isNaN(Number(n)) ? 1 : Math.floor(Number(n))
                      )
                    ),
            }
          : c
      )
    );
  }

  function autoFillPositions() {
    setCollaborators((prev: any) =>
      prev.map((c: any, i: any) => ({ ...c, signPosition: i + 1 }))
    );
  }

  function clearPositions() {
    setCollaborators((prev: any) =>
      prev.map((c: any) => {
        const { signPosition, ...rest } = c;
        return rest;
      })
    );
  }

  useEffect(() => {
    var url = window.location.href;

    var urlObj = new URL(url);

    var documentId = urlObj.searchParams.get("edit");

    const getDocument = async () => {
      if (documentId) {
        setIdEditDocument(documentId);
        await getDocumentSign(documentId);
        await getSignersEdit(documentId);
      }
    };
    getDocument();
  }, []);

  useEffect(() => {
    if (signersEdit && documentId) {
      const uniqueCollaborators = Array.from(
        new Map(
          signersEdit.map((item: any, index: number) => [
            item.email,
            {
              id: index + 1,
              name: item.text,
              email: item.email,
              addToContacts: item.addToContacts,
              sendMessageWhatsApp: item.sendMessageWhatsApp,
              phoneNumber: item.phoneNumber,
            },
          ])
        ).values()
      );

      setCollaborators(uniqueCollaborators);
    }
  }, [signersEdit]);

  useEffect(() => {
    if (tableDocuments.length === 0) {
      setTutorial(true);
    }
  }, []);

  usePrompt(
    "Você tem certeza que deseja sair? Todas as alterações feitas no documento serão perdidas.",
    isDirty
  );

  return (
    <>
      <ModaMobileLogin />
      <Joyride
        steps={steps}
        run={tutorial}
        continuous
        showSkipButton
        showProgress
        callback={handleJoyrideCallback}
        locale={{
          last: "Finalizar",
          next: "Próximo",
          back: "Voltar",
          skip: "Pular",
          close: "Fechar",
        }}
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: "#FFB800",
            textColor: "#333",
            arrowColor: "#fff",
            backgroundColor: "#fff",
          },
        }}
      />

      <LoadingSpinner />

      <MenuTop />
      <div
        className="mt-3 ml-3 mr-2 pt-4 pb-4 pl-4 d-flex"
        style={{
          height: "100%",
          backgroundColor: "#fff",
          gap: "20px",
          flexDirection: "column",
          borderRadius: "5px",
        }}
      >
        <form>
          <Row className="m-0">
            <Col md={12}>
              <FormGroup>
                <CustomTextField
                  value={nameDocument}
                  onChange={(e) => setNameDocument(e.target.value)}
                  id="document-name-input"
                  label="Nome do Documento"
                  variant="standard"
                  fullWidth
                  style={{ marginBottom: "20px" }}
                />
              </FormGroup>
            </Col>

            <Col md={12} className="mt-3">
              <h3>Adicionar signatário</h3>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Autocomplete
                  key={collaborators.length}
                  freeSolo
                  options={emailOptions}
                  onInputChange={(event, newValue) =>
                    setNewCollaborator(newValue)
                  }
                  onChange={handleSelectEmail}
                  renderInput={(params) => (
                    <CustomTextField
                      {...params}
                      value={newCollaborator}
                      label="E-mail"
                      variant="standard"
                      fullWidth
                      style={{ marginBottom: "20px" }}
                    />
                  )}
                />
              </FormGroup>
            </Col>

            {/* Nome do Signatário */}
            <Col md={6}>
              <FormGroup>
                <CustomTextField
                  value={newCollaboratorName}
                  onChange={(e) => setNewCollaboratorName(e.target.value)}
                  id="signer-name-input"
                  label="Nome do signatário"
                  variant="standard"
                  fullWidth
                  style={{ marginBottom: "20px" }}
                />
              </FormGroup>
            </Col>

            {/* Telefone */}
            <Col md={3}>
              <MaskedPhoneInput
                value={newCollaboratorPhoneNumber}
                onChange={(e) => setNewCollaboratorPhoneNumber(e.target.value)}
              />
            </Col>

            {/* Checkbox de opções */}
            <Col
              md={3}
              className="d-flex align-items-center justify-content-center mt-3"
              style={{ flexDirection: "column" }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={addToContacts}
                    onChange={(e) => setAddToContacts(e.target.checked)}
                    color="primary"
                  />
                }
                label="Adicionar signatário aos contatos"
              />
            </Col>

            <Col
              md={3}
              className="d-flex align-items-center justify-content-center mt-3"
              style={{ flexDirection: "column" }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendMessageWhatsApp}
                    onChange={(e) => setSendMessageWhatsApp(e.target.checked)}
                    color="primary"
                  />
                }
                label="Enviar Mensagem no WhatsApp"
              />
            </Col>

            <Col
              md={3}
              className="d-flex align-items-center justify-content-center mt-3"
              style={{ flexDirection: "column" }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={requireSignerDocument}
                    onChange={(e) => setRequireSignerDocument(e.target.checked)}
                    color="primary"
                  />
                }
                label="Requerer Documento do Signatário"
              />
            </Col>

            <Col
              md={12}
              className="d-flex align-items-center justify-content-start mt-1"
              style={{ gap: 16 }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sequentialSigning}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setSequentialSigning(checked);
                      if (checked) {
                        autoFillPositions();
                      } else {
                        clearPositions();
                      }
                    }}
                    color="primary"
                  />
                }
                label="Habilitar ordem de assinatura (sequencial)"
              />
            </Col>

            {/* Botão Adicionar */}
            <Col md={12} className="mt-8 text-center">
              <Button
                id="add-signatario-button"
                style={{ backgroundColor: "#F9B233", color: "#fff" }}
                onClick={handleAddCollaborator}
              >
                + Signatário(a)
              </Button>
            </Col>
          </Row>
        </form>

        {/* Lista de signatários */}
        <Row className="m-0">
          {collaborators.map((collaborator: any, index: number) => (
            <div className="col-md-6 mt-3" key={index}>
              <Card
                style={{
                  border: "1px solid #F9B233",
                  borderRadius: "10px",
                  transition: "0.3s",
                  boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                }}
                className="hover-card"
              >
                <CardBody>
                  <CardTitle tag="h5" style={{ color: "#F9B233" }}>
                    Assinatura #{index + 1}
                  </CardTitle>

                  {sequentialSigning && (
                    <Row className="mb-2">
                      <CustomTextField
                        label="Posição na fila"
                        type="number"
                        variant="outlined"
                        size="small"
                        value={collaborator.signPosition ?? ""}
                        onChange={(e) =>
                          handleSignPositionChange(index, e.target.value)
                        }
                        inputProps={{ min: 1, max: collaborators.length }}
                        style={{ width: 160, marginLeft: "15px" }}
                      />
                    </Row>
                  )}

                  <CardText className="text-muted mb-2">
                    <strong>Nome:</strong> {collaborator.name}
                  </CardText>
                  <CardText className="text-muted">
                    <strong>Email:</strong> {collaborator.email}
                  </CardText>

                  <Button
                    color="danger"
                    onClick={() => handleDeleteCollaborator(index)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <FaTrashAlt size={16} /> Remover
                  </Button>
                </CardBody>
              </Card>
            </div>
          ))}
        </Row>

        <Row className="m-0 mt-4 justify-content-end">
          <Col md={4} className="d-flex justify-content-end">
            <Button
              id="next-document"
              onClick={handleNavigate}
              style={{ backgroundColor: "#F9B233", color: "#fff" }}
            >
              Continuar
              <ArrowForwardIcon className="ml-2" />
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AddSignatories;
